export default {
  TASKS: {
    TASKS: {
      INDEX: {
        PATH: '/b/:businessSlug/tasks',
        NAME: 'tasks',
      },
      LIST: {
        PATH: '/b/:businessSlug/tasks/:type',
        NAME: 'tasks.list',
      },
      CALENDAR: {
        PATH: '/b/:businessSlug/tasks/calendar',
        NAME: 'tasks.calendar',
      },
      TASK: {
        PATH: '/b/:businessSlug/tasks/task/:taskId',
        NAME: 'tasks.task',
      },
    },
    TASK_TYPES: {
      INDEX: {
        PATH: '/b/:businessSlug/task/types',
        NAME: 'task-types.index',
      },
    },
    TASKS_TEMPLATES: {
      INDEX: {
        PATH: '/b/:businessSlug/task/templates',
        NAME: 'task-templates.index',
      },
      BUSINESS: {
        PATH: '/b/:businessSlug/task/templates/business',
        NAME: 'task-templates.business',
      },
      LMS: {
        PATH: '/b/:businessSlug/task/templates/lms',
        NAME: 'task-templates.lms',
      },
      EMS: {
        PATH: '/b/:businessSlug/task/templates/ems',
        NAME: 'task-templates.ems',
      },
    },
  },
}
